export enum PaymentStatusEnum {
	// Не оплачен
	notPaid = 1,

	// Частично оплачен
	partPaid = 2,

	// Полностью оплачен 
	fullPaid = 3,

    // выставить счет
    waitIssueInvoice = 4
}